/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefreshCreditApplication_cloneCreditApplication_CloneCreditApplicationResponse = { readonly __typename: 'CloneCreditApplicationResponse', readonly salesforceCreditId: string, readonly token: string };

export type RefreshCreditApplication_Mutation = { readonly __typename: 'Mutation', readonly cloneCreditApplication: RefreshCreditApplication_cloneCreditApplication_CloneCreditApplicationResponse };


export type RefreshCreditApplicationVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['ID']['input'];
}>;


export type RefreshCreditApplication = RefreshCreditApplication_Mutation;


export const RefreshCreditApplicationDocument = gql`
    mutation RefreshCreditApplication($salesforceCreditId: ID!) {
  cloneCreditApplication(salesforceCreditId: $salesforceCreditId) {
    salesforceCreditId
    token
  }
}
    `;
export type RefreshCreditApplicationMutationFn = Apollo.MutationFunction<RefreshCreditApplication, RefreshCreditApplicationVariables>;

/**
 * __useRefreshCreditApplication__
 *
 * To run a mutation, you first call `useRefreshCreditApplication` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCreditApplication` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCreditApplication, { data, loading, error }] = useRefreshCreditApplication({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *   },
 * });
 */
export function useRefreshCreditApplication(baseOptions?: Apollo.MutationHookOptions<RefreshCreditApplication, RefreshCreditApplicationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshCreditApplication, RefreshCreditApplicationVariables>(RefreshCreditApplicationDocument, options);
      }
export type RefreshCreditApplicationHookResult = ReturnType<typeof useRefreshCreditApplication>;
export type RefreshCreditApplicationMutationResult = Apollo.MutationResult<RefreshCreditApplication>;
export type RefreshCreditApplicationMutationOptions = Apollo.BaseMutationOptions<RefreshCreditApplication, RefreshCreditApplicationVariables>;